define(
    "diy/undo-redo/Session",
    [
    ],
    /**
     *
     * @returns {module.undoRedo.Session}
     */
    function () {
        'use strict';
        var Session;

        /**
         * @class module.undoRedo.Session
         * @template module.undoRedo.Session
         * @lends {module.undoRedo.Session.prototype}
         * @constructor
         */
        Session = Klazz.extend({
            /** @type {String} */
            key: '',

            /** @type {module.undoRedo.SessionManager} */
            sessionManager: null,

            /** @type {String} */
            sessionId: null,

            /** @type {Boolean} volatile session - entries deleted on close */
            temporary: false,
            /** @type {Array.<String>} */
            undo: [],
            /** @type {Array.<String>} */
            redo: [],
            /**
             *
             * @param {module.undoRedo.SessionManager} sessionManager
             */
            initialize: function (sessionManager) {
                this.undo = [];
                this.redo = [];
                this.sessionManager = sessionManager;
            },
            /**
             *
             * @returns {*|UndoSession.sessionId|sessionId|String}
             */
            getId: function getId() {
                var sessionId;
                try {
                    sessionId = this.sessionManager.getSessionIdForKey(this.key);
                } catch (err) {
                    //ups ... session does not officially exists anymore so ...
                    this.regenerate();
                    return this.sessionManager.getSessionIdForKey(this.key);
                }
                return sessionId;
            },
            /**
             *
             * @returns {module.undoRedo.Session}
             */
            regenerate: function regenerate() {
                this.initialize(this.sessionManager);
                var me = this.sessionManager.openSession();
                this.sessionId = me.getSessionId();
                this.key = me.getKey();
                me.setTemporary(this.temporary);
                return this;
            },
            /**
             *
             * @param {!String} key
             * @returns {module.undoRedo.Session}
             */
            setKey: function setKey(key) {
                this.key = key;
                return this;
            },
            /**
             *
             * @returns {String}
             */
            getKey: function getKey() {
                return this.key;
            },
            /**
             *
             * @param {!String} sessionId
             * @returns {module.undoRedo.Session}
             */
            setSessionId: function setSessionId(sessionId) {
                this.sessionId = sessionId;
                return this;
            },
            /**
             *
             * @returns {?String}
             */
            getSessionId: function getSessionId() {
                return this.sessionId;
            },
            /**
             *
             * @param {Boolean=} temporary
             * @returns {module.undoRedo.Session}
             */
            setTemporary: function setTemporary(temporary) {
                this.temporary = (temporary === true || temporary === false) ? temporary : true;

                return this;
            },
            /**
             *
             * @returns {Boolean}
             */
            getTemporary: function getTemporary() {
                return this.temporary;
            },
            /**
             * @returns {Boolean}
             */
            isVolatile: function isVolatile() {
                return this.temporary;
            },
            /**
             *
             * @param {Array.<String>} undo
             * @returns {module.undoRedo.Session}
             */
            setUndo: function setUndo(undo) {
                this.undo = undo;
                return this;
            },
            /**
             *
             * @param {String} entryKey
             * @returns {Number}
             */
            undoAdd: function undoAdd(entryKey) {
                this.undo.push(entryKey);
                return this.undo.length;
            },
            /**
             *
             * @returns {Array.<String>}
             */
            getUndo: function getUndo() {
                return this.undo;
            },
            /**
             *
             * @param {Array.<String>} redo
             * @returns {module.undoRedo.Session}
             */
            setRedo: function setRedo(redo) {
                this.redo = redo;
                return this;
            },
            /**
             *
             * @param {String} entryKey
             * @returns {Number}
             */
            redoAdd: function redoAdd(entryKey) {
                this.redo.unshift(entryKey);
                return this.redo.length;
            },
            /**
             *
             * @returns {Array.<String>}
             */
            getRedo: function getRedo() {
                return this.redo;
            },
            close: function close() {
                return this.sessionManager.closeSession(this);
            },
            getNextIndex: function getNextIndex() {
                return this.undo.length + 1;
            },
            /**
             *
             * @returns {{key: String, sessionId: String, volatile: Boolean, undo: String[], redo: String[]}}
             */
            sleep: function sleep() {
                return {
                    key: this.key,
                    sessionId: this.sessionId,
                    temporary: this.temporary,
                    undo: this.undo,
                    redo: this.redo
                };
            }

        });


        return Session;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/Session.js
 ** module id = 894
 ** module chunks = 0
 **/